import { render, staticRenderFns } from "./RestrictAccess.vue?vue&type=template&id=18cde70a&lang=html"
import script from "./RestrictAccess.vue?vue&type=script&lang=js"
export * from "./RestrictAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports